/* tslint:disable */
/* eslint-disable */
/**
 * Juhsis REST Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AlphaResult } from '../models';
// @ts-ignore
import type { AnalysisFailedRequest } from '../models';
// @ts-ignore
import type { AnalysisResultRequest } from '../models';
// @ts-ignore
import type { ArticleDetailsResponse } from '../models';
// @ts-ignore
import type { ForceBackfillRequest } from '../models';
// @ts-ignore
import type { ForceBackfillResponse } from '../models';
// @ts-ignore
import type { PendingArticlesResponse } from '../models';
// @ts-ignore
import type { PublisherMetrics } from '../models';
// @ts-ignore
import type { PublisherMetricsBatchRequest } from '../models';
// @ts-ignore
import type { PublisherMetricsBatchResponse } from '../models';
// @ts-ignore
import type { SectorDetailResponse } from '../models';
// @ts-ignore
import type { SectorSummary } from '../models';
// @ts-ignore
import type { SimpleArticle } from '../models';
// @ts-ignore
import type { SpotPriceResponse } from '../models';
// @ts-ignore
import type { StockArticleDto } from '../models';
// @ts-ignore
import type { StockPriceBar } from '../models';
/**
 * AlphaAnalysisApi - axios parameter creator
 * @export
 */
export const AlphaAnalysisApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Backfill 12 months of price data for all tickers in StockArticles (worker auth). Call repeatedly until tickersProcessed=0.
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backfillStockPrices: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/alpha-analysis/backfill-stock-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Batch-fetch publisher metrics by authorId (max 100). Missing publishers are simply omitted from the response.
         * @param {PublisherMetricsBatchRequest} publisherMetricsBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchPublisherMetrics: async (publisherMetricsBatchRequest: PublisherMetricsBatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publisherMetricsBatchRequest' is not null or undefined
            assertParamExists('batchPublisherMetrics', 'publisherMetricsBatchRequest', publisherMetricsBatchRequest)
            const localVarPath = `/api/alpha-analysis/publishers/metrics:batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publisherMetricsBatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Force-backfill 5y of price data for an explicit list of tickers (admin only). When force=true, bypasses the \'has-recent-history\' short-circuit and always calls Polygon. Max 10 tickers per request (Lambda has a 29s timeout and Polygon rate-limits at ~1.1s/call).
         * @param {ForceBackfillRequest} forceBackfillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceBackfillTickers: async (forceBackfillRequest: ForceBackfillRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'forceBackfillRequest' is not null or undefined
            assertParamExists('forceBackfillTickers', 'forceBackfillRequest', forceBackfillRequest)
            const localVarPath = `/api/alpha-analysis/backfill-stock-prices/tickers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forceBackfillRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all analyses by a specific analyst
         * @param {string} authorId 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalystResults: async (authorId: string, days?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorId' is not null or undefined
            assertParamExists('getAnalystResults', 'authorId', authorId)
            const localVarPath = `/api/alpha-analysis/analysts/{authorId}`
                .replace(`{${"authorId"}}`, encodeURIComponent(String(authorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch pending articles for analysis (Claude Code worker)
         * @param {number} [limit] 
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingArticles: async (limit?: number, agentId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/alpha-analysis/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (agentId !== undefined) {
                localVarQueryParameter['agentId'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get earner-score metrics for a single publisher (article author)
         * @param {string} authorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherMetrics: async (authorId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorId' is not null or undefined
            assertParamExists('getPublisherMetrics', 'authorId', authorId)
            const localVarPath = `/api/alpha-analysis/publishers/{authorId}/metrics`
                .replace(`{${"authorId"}}`, encodeURIComponent(String(authorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch full SA article content (Claude Code worker)
         * @param {string} credentialKey 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaArticle: async (credentialKey: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'credentialKey' is not null or undefined
            assertParamExists('getSaArticle', 'credentialKey', credentialKey)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('getSaArticle', 'articleId', articleId)
            const localVarPath = `/api/alpha-analysis/sa/article/{credentialKey}/{articleId}`
                .replace(`{${"credentialKey"}}`, encodeURIComponent(String(credentialKey)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch SA Premium (Alpha Picks) articles (Claude Code worker)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaPremiumPortfolio: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/alpha-analysis/sa/premium-portfolio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch SA Pro quant portfolio articles (Claude Code worker)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaQuantPortfolio: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/alpha-analysis/sa/quant-portfolio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get sector trend and article feed
         * @param {string} sector 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectorDetail: async (sector: string, days?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sector' is not null or undefined
            assertParamExists('getSectorDetail', 'sector', sector)
            const localVarPath = `/api/alpha-analysis/sectors/{sector}`
                .replace(`{${"sector"}}`, encodeURIComponent(String(sector)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all sectors with aggregated outlook scores
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectors: async (days?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/alpha-analysis/sectors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the most recent 1-minute close (Polygon) for a ticker, used to anchor the forecast at the live tape
         * @param {string} ticker 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpotPrice: async (ticker: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticker' is not null or undefined
            assertParamExists('getSpotPrice', 'ticker', ticker)
            const localVarPath = `/api/alpha-analysis/spot-price/{ticker}`
                .replace(`{${"ticker"}}`, encodeURIComponent(String(ticker)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all analyses for a given stock ticker
         * @param {string} ticker 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockAnalyses: async (ticker: string, days?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticker' is not null or undefined
            assertParamExists('getStockAnalyses', 'ticker', ticker)
            const localVarPath = `/api/alpha-analysis/stocks/{ticker}`
                .replace(`{${"ticker"}}`, encodeURIComponent(String(ticker)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get articles for a ticker from the StockArticles table
         * @param {string} ticker 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockArticles: async (ticker: string, days?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticker' is not null or undefined
            assertParamExists('getStockArticles', 'ticker', ticker)
            const localVarPath = `/api/alpha-analysis/stock-articles/{ticker}`
                .replace(`{${"ticker"}}`, encodeURIComponent(String(ticker)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get daily OHLC price bars for a ticker (last N months)
         * @param {string} ticker 
         * @param {number} [months] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockPrices: async (ticker: string, months?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticker' is not null or undefined
            assertParamExists('getStockPrices', 'ticker', ticker)
            const localVarPath = `/api/alpha-analysis/stock-prices/{ticker}`
                .replace(`{${"ticker"}}`, encodeURIComponent(String(ticker)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (months !== undefined) {
                localVarQueryParameter['months'] = months;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark article analysis as failed (Claude Code worker)
         * @param {AnalysisFailedRequest} analysisFailedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFailed: async (analysisFailedRequest: AnalysisFailedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisFailedRequest' is not null or undefined
            assertParamExists('postFailed', 'analysisFailedRequest', analysisFailedRequest)
            const localVarPath = `/api/alpha-analysis/failed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(analysisFailedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit analysis result (Claude Code worker)
         * @param {AnalysisResultRequest} analysisResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResult: async (analysisResultRequest: AnalysisResultRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisResultRequest' is not null or undefined
            assertParamExists('postResult', 'analysisResultRequest', analysisResultRequest)
            const localVarPath = `/api/alpha-analysis/results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(analysisResultRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync today\'s OHLC for all known tickers via Polygon grouped-daily endpoint (worker auth).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDailyStockPrices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/alpha-analysis/sync-daily-stock-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trigger SA article backfill Lambda (admin only). Uses cursor-based date-range pagination.
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerBackfill1: async (startDate: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('triggerBackfill1', 'startDate', startDate)
            const localVarPath = `/api/alpha-analysis/backfill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trigger the publisher-metrics backfill Lambda asynchronously (admin only). Backfills priceAtPublish + 10 forward-window price snapshots on StockArticles rows, then recomputes earner scores per publisher.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerPublisherMetricsBackfill: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/alpha-analysis/publisher-metrics/backfill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AlphaAnalysisApi - functional programming interface
 * @export
 */
export const AlphaAnalysisApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AlphaAnalysisApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Backfill 12 months of price data for all tickers in StockArticles (worker auth). Call repeatedly until tickersProcessed=0.
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async backfillStockPrices(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.backfillStockPrices(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.backfillStockPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Batch-fetch publisher metrics by authorId (max 100). Missing publishers are simply omitted from the response.
         * @param {PublisherMetricsBatchRequest} publisherMetricsBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async batchPublisherMetrics(publisherMetricsBatchRequest: PublisherMetricsBatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublisherMetricsBatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.batchPublisherMetrics(publisherMetricsBatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.batchPublisherMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Force-backfill 5y of price data for an explicit list of tickers (admin only). When force=true, bypasses the \'has-recent-history\' short-circuit and always calls Polygon. Max 10 tickers per request (Lambda has a 29s timeout and Polygon rate-limits at ~1.1s/call).
         * @param {ForceBackfillRequest} forceBackfillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forceBackfillTickers(forceBackfillRequest: ForceBackfillRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForceBackfillResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forceBackfillTickers(forceBackfillRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.forceBackfillTickers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all analyses by a specific analyst
         * @param {string} authorId 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnalystResults(authorId: string, days?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AlphaResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnalystResults(authorId, days, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.getAnalystResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch pending articles for analysis (Claude Code worker)
         * @param {number} [limit] 
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingArticles(limit?: number, agentId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PendingArticlesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingArticles(limit, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.getPendingArticles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get earner-score metrics for a single publisher (article author)
         * @param {string} authorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublisherMetrics(authorId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublisherMetrics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublisherMetrics(authorId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.getPublisherMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch full SA article content (Claude Code worker)
         * @param {string} credentialKey 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSaArticle(credentialKey: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSaArticle(credentialKey, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.getSaArticle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch SA Premium (Alpha Picks) articles (Claude Code worker)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSaPremiumPortfolio(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimpleArticle>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSaPremiumPortfolio(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.getSaPremiumPortfolio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch SA Pro quant portfolio articles (Claude Code worker)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSaQuantPortfolio(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimpleArticle>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSaQuantPortfolio(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.getSaQuantPortfolio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get sector trend and article feed
         * @param {string} sector 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSectorDetail(sector: string, days?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SectorDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSectorDetail(sector, days, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.getSectorDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all sectors with aggregated outlook scores
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSectors(days?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SectorSummary>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSectors(days, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.getSectors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the most recent 1-minute close (Polygon) for a ticker, used to anchor the forecast at the live tape
         * @param {string} ticker 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpotPrice(ticker: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpotPriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpotPrice(ticker, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.getSpotPrice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all analyses for a given stock ticker
         * @param {string} ticker 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStockAnalyses(ticker: string, days?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AlphaResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStockAnalyses(ticker, days, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.getStockAnalyses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get articles for a ticker from the StockArticles table
         * @param {string} ticker 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStockArticles(ticker: string, days?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockArticleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStockArticles(ticker, days, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.getStockArticles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get daily OHLC price bars for a ticker (last N months)
         * @param {string} ticker 
         * @param {number} [months] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStockPrices(ticker: string, months?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StockPriceBar>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStockPrices(ticker, months, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.getStockPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark article analysis as failed (Claude Code worker)
         * @param {AnalysisFailedRequest} analysisFailedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFailed(analysisFailedRequest: AnalysisFailedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFailed(analysisFailedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.postFailed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit analysis result (Claude Code worker)
         * @param {AnalysisResultRequest} analysisResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postResult(analysisResultRequest: AnalysisResultRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postResult(analysisResultRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.postResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync today\'s OHLC for all known tickers via Polygon grouped-daily endpoint (worker auth).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncDailyStockPrices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncDailyStockPrices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.syncDailyStockPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Trigger SA article backfill Lambda (admin only). Uses cursor-based date-range pagination.
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerBackfill1(startDate: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerBackfill1(startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.triggerBackfill1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Trigger the publisher-metrics backfill Lambda asynchronously (admin only). Backfills priceAtPublish + 10 forward-window price snapshots on StockArticles rows, then recomputes earner scores per publisher.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerPublisherMetricsBackfill(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerPublisherMetricsBackfill(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlphaAnalysisApi.triggerPublisherMetricsBackfill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AlphaAnalysisApi - factory interface
 * @export
 */
export const AlphaAnalysisApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AlphaAnalysisApiFp(configuration)
    return {
        /**
         * 
         * @summary Backfill 12 months of price data for all tickers in StockArticles (worker auth). Call repeatedly until tickersProcessed=0.
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backfillStockPrices(limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.backfillStockPrices(limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Batch-fetch publisher metrics by authorId (max 100). Missing publishers are simply omitted from the response.
         * @param {PublisherMetricsBatchRequest} publisherMetricsBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchPublisherMetrics(publisherMetricsBatchRequest: PublisherMetricsBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublisherMetricsBatchResponse> {
            return localVarFp.batchPublisherMetrics(publisherMetricsBatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Force-backfill 5y of price data for an explicit list of tickers (admin only). When force=true, bypasses the \'has-recent-history\' short-circuit and always calls Polygon. Max 10 tickers per request (Lambda has a 29s timeout and Polygon rate-limits at ~1.1s/call).
         * @param {ForceBackfillRequest} forceBackfillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceBackfillTickers(forceBackfillRequest: ForceBackfillRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForceBackfillResponse> {
            return localVarFp.forceBackfillTickers(forceBackfillRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all analyses by a specific analyst
         * @param {string} authorId 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnalystResults(authorId: string, days?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<AlphaResult>> {
            return localVarFp.getAnalystResults(authorId, days, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch pending articles for analysis (Claude Code worker)
         * @param {number} [limit] 
         * @param {string} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingArticles(limit?: number, agentId?: string, options?: RawAxiosRequestConfig): AxiosPromise<PendingArticlesResponse> {
            return localVarFp.getPendingArticles(limit, agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get earner-score metrics for a single publisher (article author)
         * @param {string} authorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublisherMetrics(authorId: string, options?: RawAxiosRequestConfig): AxiosPromise<PublisherMetrics> {
            return localVarFp.getPublisherMetrics(authorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch full SA article content (Claude Code worker)
         * @param {string} credentialKey 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaArticle(credentialKey: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<ArticleDetailsResponse> {
            return localVarFp.getSaArticle(credentialKey, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch SA Premium (Alpha Picks) articles (Claude Code worker)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaPremiumPortfolio(options?: RawAxiosRequestConfig): AxiosPromise<Array<SimpleArticle>> {
            return localVarFp.getSaPremiumPortfolio(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch SA Pro quant portfolio articles (Claude Code worker)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaQuantPortfolio(options?: RawAxiosRequestConfig): AxiosPromise<Array<SimpleArticle>> {
            return localVarFp.getSaQuantPortfolio(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get sector trend and article feed
         * @param {string} sector 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectorDetail(sector: string, days?: number, options?: RawAxiosRequestConfig): AxiosPromise<SectorDetailResponse> {
            return localVarFp.getSectorDetail(sector, days, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all sectors with aggregated outlook scores
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectors(days?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<SectorSummary>> {
            return localVarFp.getSectors(days, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the most recent 1-minute close (Polygon) for a ticker, used to anchor the forecast at the live tape
         * @param {string} ticker 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpotPrice(ticker: string, options?: RawAxiosRequestConfig): AxiosPromise<SpotPriceResponse> {
            return localVarFp.getSpotPrice(ticker, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all analyses for a given stock ticker
         * @param {string} ticker 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockAnalyses(ticker: string, days?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<AlphaResult>> {
            return localVarFp.getStockAnalyses(ticker, days, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get articles for a ticker from the StockArticles table
         * @param {string} ticker 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockArticles(ticker: string, days?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<StockArticleDto>> {
            return localVarFp.getStockArticles(ticker, days, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get daily OHLC price bars for a ticker (last N months)
         * @param {string} ticker 
         * @param {number} [months] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStockPrices(ticker: string, months?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<StockPriceBar>> {
            return localVarFp.getStockPrices(ticker, months, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark article analysis as failed (Claude Code worker)
         * @param {AnalysisFailedRequest} analysisFailedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFailed(analysisFailedRequest: AnalysisFailedRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postFailed(analysisFailedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit analysis result (Claude Code worker)
         * @param {AnalysisResultRequest} analysisResultRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResult(analysisResultRequest: AnalysisResultRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postResult(analysisResultRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync today\'s OHLC for all known tickers via Polygon grouped-daily endpoint (worker auth).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncDailyStockPrices(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.syncDailyStockPrices(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trigger SA article backfill Lambda (admin only). Uses cursor-based date-range pagination.
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerBackfill1(startDate: string, endDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.triggerBackfill1(startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trigger the publisher-metrics backfill Lambda asynchronously (admin only). Backfills priceAtPublish + 10 forward-window price snapshots on StockArticles rows, then recomputes earner scores per publisher.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerPublisherMetricsBackfill(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.triggerPublisherMetricsBackfill(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AlphaAnalysisApi - object-oriented interface
 * @export
 * @class AlphaAnalysisApi
 * @extends {BaseAPI}
 */
export class AlphaAnalysisApi extends BaseAPI {
    /**
     * 
     * @summary Backfill 12 months of price data for all tickers in StockArticles (worker auth). Call repeatedly until tickersProcessed=0.
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public backfillStockPrices(limit?: number, options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).backfillStockPrices(limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Batch-fetch publisher metrics by authorId (max 100). Missing publishers are simply omitted from the response.
     * @param {PublisherMetricsBatchRequest} publisherMetricsBatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public batchPublisherMetrics(publisherMetricsBatchRequest: PublisherMetricsBatchRequest, options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).batchPublisherMetrics(publisherMetricsBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Force-backfill 5y of price data for an explicit list of tickers (admin only). When force=true, bypasses the \'has-recent-history\' short-circuit and always calls Polygon. Max 10 tickers per request (Lambda has a 29s timeout and Polygon rate-limits at ~1.1s/call).
     * @param {ForceBackfillRequest} forceBackfillRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public forceBackfillTickers(forceBackfillRequest: ForceBackfillRequest, options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).forceBackfillTickers(forceBackfillRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all analyses by a specific analyst
     * @param {string} authorId 
     * @param {number} [days] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public getAnalystResults(authorId: string, days?: number, options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).getAnalystResults(authorId, days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch pending articles for analysis (Claude Code worker)
     * @param {number} [limit] 
     * @param {string} [agentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public getPendingArticles(limit?: number, agentId?: string, options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).getPendingArticles(limit, agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get earner-score metrics for a single publisher (article author)
     * @param {string} authorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public getPublisherMetrics(authorId: string, options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).getPublisherMetrics(authorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch full SA article content (Claude Code worker)
     * @param {string} credentialKey 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public getSaArticle(credentialKey: string, articleId: string, options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).getSaArticle(credentialKey, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch SA Premium (Alpha Picks) articles (Claude Code worker)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public getSaPremiumPortfolio(options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).getSaPremiumPortfolio(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch SA Pro quant portfolio articles (Claude Code worker)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public getSaQuantPortfolio(options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).getSaQuantPortfolio(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get sector trend and article feed
     * @param {string} sector 
     * @param {number} [days] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public getSectorDetail(sector: string, days?: number, options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).getSectorDetail(sector, days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all sectors with aggregated outlook scores
     * @param {number} [days] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public getSectors(days?: number, options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).getSectors(days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the most recent 1-minute close (Polygon) for a ticker, used to anchor the forecast at the live tape
     * @param {string} ticker 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public getSpotPrice(ticker: string, options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).getSpotPrice(ticker, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all analyses for a given stock ticker
     * @param {string} ticker 
     * @param {number} [days] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public getStockAnalyses(ticker: string, days?: number, options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).getStockAnalyses(ticker, days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get articles for a ticker from the StockArticles table
     * @param {string} ticker 
     * @param {number} [days] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public getStockArticles(ticker: string, days?: number, options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).getStockArticles(ticker, days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get daily OHLC price bars for a ticker (last N months)
     * @param {string} ticker 
     * @param {number} [months] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public getStockPrices(ticker: string, months?: number, options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).getStockPrices(ticker, months, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark article analysis as failed (Claude Code worker)
     * @param {AnalysisFailedRequest} analysisFailedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public postFailed(analysisFailedRequest: AnalysisFailedRequest, options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).postFailed(analysisFailedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit analysis result (Claude Code worker)
     * @param {AnalysisResultRequest} analysisResultRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public postResult(analysisResultRequest: AnalysisResultRequest, options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).postResult(analysisResultRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync today\'s OHLC for all known tickers via Polygon grouped-daily endpoint (worker auth).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public syncDailyStockPrices(options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).syncDailyStockPrices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Trigger SA article backfill Lambda (admin only). Uses cursor-based date-range pagination.
     * @param {string} startDate 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public triggerBackfill1(startDate: string, endDate?: string, options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).triggerBackfill1(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Trigger the publisher-metrics backfill Lambda asynchronously (admin only). Backfills priceAtPublish + 10 forward-window price snapshots on StockArticles rows, then recomputes earner scores per publisher.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlphaAnalysisApi
     */
    public triggerPublisherMetricsBackfill(options?: RawAxiosRequestConfig) {
        return AlphaAnalysisApiFp(this.configuration).triggerPublisherMetricsBackfill(options).then((request) => request(this.axios, this.basePath));
    }
}

